// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_2nTBR3","container":"_10qajd","content":"_19s-2l","image":"_2Ksw8F"};